import { render, staticRenderFns } from "./custom-link.vue?vue&type=template&id=54423cae&scoped=true&"
import script from "./custom-link.vue?vue&type=script&lang=js&"
export * from "./custom-link.vue?vue&type=script&lang=js&"
import style0 from "./custom-link.vue?vue&type=style&index=0&id=54423cae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54423cae",
  null
  
)

export default component.exports